import { createReducer, on } from '@ngrx/store';

import { TagsLabelsActions } from '@core/store/admin/tags-labels/tags-labels.actions';
import {
  TagsLabelsState,
  initialTagsLabelsState
} from '@core/store/admin/tags-labels/tags-labels.state';

export const tagsLabelsReducer = createReducer(
  initialTagsLabelsState,

  // Tags list
  on(
    TagsLabelsActions.loadTags,
    (state): TagsLabelsState => ({
      ...state,
      tagsLoading: true,
      tagsError: null
    })
  ),
  on(
    TagsLabelsActions.loadTagsSuccess,
    (state, { tags }): TagsLabelsState => ({
      ...state,
      tags,
      tagsLoading: false
    })
  ),
  on(
    TagsLabelsActions.loadTagsFailure,
    (state, { error }): TagsLabelsState => ({
      ...state,
      tagsLoading: false,
      tagsError: error
    })
  ),

  // Create tag
  on(
    TagsLabelsActions.createTag,
    (state): TagsLabelsState => ({
      ...state,
      formSaving: true,
      formError: null,
      formSuccess: false
    })
  ),
  on(
    TagsLabelsActions.createTagSuccess,
    (state, { tag }): TagsLabelsState => ({
      ...state,
      tags: [...state.tags, tag],
      formSaving: false,
      formSuccess: true
    })
  ),
  on(
    TagsLabelsActions.createTagFailure,
    (state, { error }): TagsLabelsState => ({
      ...state,
      formSaving: false,
      formError: error
    })
  ),

  // Update tag
  on(
    TagsLabelsActions.updateTag,
    (state): TagsLabelsState => ({
      ...state,
      formSaving: true,
      formError: null,
      formSuccess: false
    })
  ),
  on(
    TagsLabelsActions.updateTagSuccess,
    (state, { tag }): TagsLabelsState => ({
      ...state,
      tags: state.tags.map((t) => (t.id === tag.id ? tag : t)),
      formSaving: false,
      formSuccess: true
    })
  ),
  on(
    TagsLabelsActions.updateTagFailure,
    (state, { error }): TagsLabelsState => ({
      ...state,
      formSaving: false,
      formError: error
    })
  ),

  // Delete tag
  on(
    TagsLabelsActions.deleteTag,
    (state): TagsLabelsState => ({
      ...state,
      formSaving: true,
      formError: null
    })
  ),
  on(
    TagsLabelsActions.deleteTagSuccess,
    (state, { id }): TagsLabelsState => ({
      ...state,
      tags: state.tags.filter((t) => t.id !== id),
      formSaving: false
    })
  ),
  on(
    TagsLabelsActions.deleteTagFailure,
    (state, { error }): TagsLabelsState => ({
      ...state,
      formSaving: false,
      formError: error
    })
  ),

  // Labels list
  on(
    TagsLabelsActions.loadLabels,
    (state): TagsLabelsState => ({
      ...state,
      labelsLoading: true,
      labelsError: null
    })
  ),
  on(
    TagsLabelsActions.loadLabelsSuccess,
    (state, { labels }): TagsLabelsState => ({
      ...state,
      labels,
      labelsLoading: false
    })
  ),
  on(
    TagsLabelsActions.loadLabelsFailure,
    (state, { error }): TagsLabelsState => ({
      ...state,
      labelsLoading: false,
      labelsError: error
    })
  ),

  // Create label
  on(
    TagsLabelsActions.createLabel,
    (state): TagsLabelsState => ({
      ...state,
      formSaving: true,
      formError: null,
      formSuccess: false
    })
  ),
  on(
    TagsLabelsActions.createLabelSuccess,
    (state, { label }): TagsLabelsState => ({
      ...state,
      labels: [...state.labels, label],
      formSaving: false,
      formSuccess: true
    })
  ),
  on(
    TagsLabelsActions.createLabelFailure,
    (state, { error }): TagsLabelsState => ({
      ...state,
      formSaving: false,
      formError: error
    })
  ),

  // Update label
  on(
    TagsLabelsActions.updateLabel,
    (state): TagsLabelsState => ({
      ...state,
      formSaving: true,
      formError: null,
      formSuccess: false
    })
  ),
  on(
    TagsLabelsActions.updateLabelSuccess,
    (state, { label }): TagsLabelsState => ({
      ...state,
      labels: state.labels.map((l) => (l.id === label.id ? label : l)),
      formSaving: false,
      formSuccess: true
    })
  ),
  on(
    TagsLabelsActions.updateLabelFailure,
    (state, { error }): TagsLabelsState => ({
      ...state,
      formSaving: false,
      formError: error
    })
  ),

  // Delete label
  on(
    TagsLabelsActions.deleteLabel,
    (state): TagsLabelsState => ({
      ...state,
      formSaving: true,
      formError: null
    })
  ),
  on(
    TagsLabelsActions.deleteLabelSuccess,
    (state, { id }): TagsLabelsState => ({
      ...state,
      labels: state.labels.filter((l) => l.id !== id),
      formSaving: false
    })
  ),
  on(
    TagsLabelsActions.deleteLabelFailure,
    (state, { error }): TagsLabelsState => ({
      ...state,
      formSaving: false,
      formError: error
    })
  ),

  // Reset form
  on(
    TagsLabelsActions.resetFormState,
    (state): TagsLabelsState => ({
      ...state,
      formSaving: false,
      formError: null,
      formSuccess: false
    })
  )
);
